module.exports = {
  buildVersion: "0.1.40",
  buildDate: 1771499404895,
}